import { render, staticRenderFns } from "./ioRecord.vue?vue&type=template&id=82d2e17a&scoped=true&"
import script from "./ioRecord.vue?vue&type=script&lang=js&"
export * from "./ioRecord.vue?vue&type=script&lang=js&"
import style0 from "./ioRecord.vue?vue&type=style&index=0&id=82d2e17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d2e17a",
  null
  
)

export default component.exports